import { IProductDefinitionList, NodeObjectRepository } from '@/models/assembly';

export const BasicToplanti = {
  'basic-toplanti': {
    steps: [
      {
        order: 1,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {
          const ayak = repository.get('basic_u_ayak_800luk_ewa_624_yyy')
            .show();


          const kose = repository.get('basic_kose_alm_adaptor_7021_yyy').changePosition((x, y, z) => {
            return {
              y: y + 20,
            };
          });



          const civata = repository.get('basic_m8_70_imbus_civata_yyy').changePosition((x, y, z) => {
            return {
              y: y + 50,
            };
          });
          kose.show();
          kose.resetPosition(1.5);
          civata.show();
          civata.resetPosition(2);

          repository.track(ayak, kose , civata);
        },
      },
      {
        order: 2,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {



          const pingo = repository.get('basic_pls_sabit_pingo_m8_gri_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 20,
              };
            });


          pingo.show();
          pingo.resetPosition(1.5);

          repository.track(pingo);
        },
      },
      {
        order: 3,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const atki = repository.get('basic_tp1_atki_1800_7021_byl_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 20,
              };
            })
            .show()
            .resetPosition(1.5);

          repository.track(atki);
        },
      },
      {
        order: 4,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tb = repository.get('basic_top_ms__tb_220_110_3_yyy')
          .changePosition((x, y, z) => {
            return {
              y: y + 50,
            };
          });

          const minifix = repository.get('basic_minifix_dubel_yyy')
          .changePosition((x, y, z) => {
            return {
              y: y - 20,
            };
          });

          const tabla = repository.get('basic_tabla_bagl_pls_tampo_syh_yyy')
          .changePosition((x, y, z) => {
            return {
              y: y - 20,
            };
          });

          const civata = repository.get('basic_m6_60_imbus_civata_yyy')
          .changePosition((x, y, z) => {
            return {
              y: y - 20,
            };
          });



          tb.show();
          tb.resetPosition(1.5);
          minifix.show();
          minifix.resetPosition(1.5);
          tabla.show();
          tabla.resetPosition(1.5);
          civata.show();
          civata.resetPosition(1.5);
          repository.track(tb,minifix,tabla,civata);
        },
      },
      {
        order: 5,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const dik = repository.get('basic__tipmas_ar_mil_ewa624_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 20,
              };
            })
            .show();



          const vida = repository.get('basic_2_22_yhb_m_uclu_vida_yyy')
          .changePosition((x, y, z) => {
            return {
              z: z - 20,
            };
          })
          .show();

          dik.resetPosition(1.5);
          vida.resetPosition(1.5);

          repository.track(dik,vida);
        },
      },


    ],
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/defs/basic-toplanti.ts